/**
 * Created for the supplier portal.
 */
define('portalUsersController',[
  'module',
  'app',
  'jquery',
  'portalUsersView',
  'entities/suppliers/portal_users'
], function (
  Module,
  App,
  $,
  PortalUsersView
) {
  'use strict';

  var PortalUsersController = {

    showView: function (done) {
      $.when(App.request('portal-users:suppliers')).done(function (suppliers) {
        done(new PortalUsersView({suppliers: suppliers}));
      });
    }
  };

  Module.exports = PortalUsersController;
});

